import { useMemo } from 'react';
import { keyBy } from 'lodash-es';
import { useContacts } from '~/hooks/reactQuery/queries/useContacts';
export const useGetDraftContact = (draft)=>{
    const { contacts } = useContacts();
    const contactMap = useMemo(()=>keyBy(contacts || [], (c)=>c.id()), [
        contacts
    ]);
    const clientContactId = draft.clientContactId();
    return clientContactId ? contactMap[clientContactId] || null : null;
};
